import { render } from "./scoreComplain.vue?vue&type=template&id=274dbeee&scoped=true"
import script from "./scoreComplain.vue?vue&type=script&lang=js"
export * from "./scoreComplain.vue?vue&type=script&lang=js"

import "./scoreComplain.vue?vue&type=style&index=0&id=274dbeee&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274dbeee"]])

export default __exports__